module.exports = __webpack_public_path__ + "media/assets/images/blog/inbox-zero-d6379041ec386a40e70e826d73be57d2.png";